import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchBranch } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const BranchDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const branchName = getValues().branch;
  const selectedBranch = watch("branch_id");

  const {
    data: branches,
    isLoading,
    error,
  } = useQuery(["branch"], () => fetchBranch(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(
    () =>
      branches?.data?.branch_data?.map((branch) => ({
        value: branch.branch_id,
        label: branch.branch,
      })) || [],
    [branches]
  );

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === rowData?.branch_id
      );
      setValue("branch_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  const selectedOption = options.find(
    (option) => option.value === selectedBranch || branchName
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Branches</div>;

  return (
    <Controller
      name="branch_id"
      control={control}
      rules={{
        required: required ? "Branch is required" : false,
        validate: (value) => {
          if (required && !value) return "Branch is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Branch"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("branch_id", value);
          }}
          className={`react-select-container ${errors.branch_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default BranchDropdown;
